import React from "react";
import { ShieldCheck } from "lucide-react";

/** Kurzer, ruhiger Vertrauenshinweis. Bewusst keine Fachsprache.

  Variante:
   - "ribbon" (default): dezent unter Seitenkopf, paper-Look
   - "card": eigene Karte (für Empty States)
*/
export default function TrustHint({ children, icon: Icon = ShieldCheck, variant = "ribbon", testId = "trust-hint" }) {
  if (variant === "card") {
    return (
      <div data-testid={testId} className="rounded-2xl border border-emerald-200/70 bg-emerald-50/40 p-5 flex items-start gap-3">
        <div className="h-9 w-9 rounded-xl bg-emerald-100 border border-emerald-200 flex items-center justify-center shrink-0">
          <Icon className="h-4 w-4 text-emerald-700" strokeWidth={1.5} />
        </div>
        <p className="text-sm text-emerald-900/90 leading-relaxed">{children}</p>
      </div>
    );
  }
  return (
    <div data-testid={testId} className="inline-flex items-center gap-2 text-xs text-slate-600 bg-white/70 border border-slate-200 rounded-full pl-3 pr-4 py-1.5">
      <Icon className="h-3.5 w-3.5 text-emerald-700" strokeWidth={1.6} />
      <span className="leading-snug">{children}</span>
    </div>
  );
}
